<template>
	<div class="card mt-4">
        <div class="card-header">
            <div class="row">
	            <div class="d-flex justify-content-between container-fluid">
			        <div class="text-muted fs-19">
			            <strong>Totais</strong>
			        </div>
				</div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-primary">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
		            			Total de Pedidos
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">
		        				{{ dados.total }}	
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-paste fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-primary">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
		            			Total de Pedidos Ano
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">
		        				{{ dados.total_ano }}	
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-paste fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-primary">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
		            			Total de Pedidos Semestre
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">
		        				{{ dados.total_semestre }}	
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-paste fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
            	<div class="col-xl-3 col-md-6 mb-4">
            		<bga2-info-card classe="border-left-primary">
            			<div class="col mr-2">
		        			<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
		            			Total de Pedidos Trimestre
		        			</div>
		        			<div class="h5 mb-0 font-weight-bold text-gray-800">
		        				{{ dados.total_trimestre }}	
		        			</div>
		    			</div>
						<div class="col-auto">
		        			<i class="fas fa-paste fa-2x text-gray-300"></i>
		    			</div>
            		</bga2-info-card>
            	</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['date'],
		data(){
			return {
				dados: []
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/relatorios/pedidos/'+this.date)
	            .then(response => {
	            	this.dados = response.data;
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
		},
	}
</script>